import React, { useState } from 'react';
import Form from './Form';
import Resultat from './Resultat'

function App() {
  const [montant, setMontant] = useState("")
  const [puissance, setPuissance] = useState("")
  const [imposable, setImposable] = useState("")
  const [resultat, setResultat] = useState()

  const calculer = () => {
    if (!montant || ! puissance || !imposable) {
      setResultat({
        hasError: true,
        message: "Tous les champs sont obligatoires"
      })
    } else if (puissance > 3) {
      setResultat({
        hasError: true,
        message: "La puissance ne peut pas excéder 3 kWc"
      })
    } else {
      let pourcentage = 0.5;
      if (imposable === "oui") pourcentage = 0.3;
      let aide = (pourcentage * Math.min (montant, Math.round(puissance*3500)));

      setResultat({
        hasError: false,
        // Si imposable, la subvention est égale à 30% du minimum entre le montant de l'installation et le plafond de 3500€ par kWc
        // Si non imposable, la subvention est égale à 50% du minimum entre le montant de l'installation et le plafond de 3500€ par kWc
        //aide: (imposable === "oui" ? 0.3 : 0.5) * Math.min(montant, puissance*3500),
        aide : aide,
        imposable: imposable
      })
    }
  }

  return (
    <div className="container">
      <Form 
        montant={montant}
        setMontant={setMontant}
        puissance={puissance}
        setPuissance={setPuissance}
        imposable={imposable}
        setImposable={setImposable}
        setResultat={setResultat}/>
      <div className="text-center"  style={{ marginBottom: "15px"}}>
        <button className="btn btn-primary mb-3" onClick={() => calculer()}>Calculer</button>
      </div>
      {resultat && <Resultat {...resultat}/>}
    </div>
  );
}

export default App;
